import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { GetAdditionalEntityDetailsForSummaryDocumentResponse } from '../@types/GetAdditionalEntityDetailsForSummaryDocument'
import { MatchedIndividualEntityDetailsForSummaryDocument } from '../Types/getEntityDetailsForSummaryDocument'

type Store = {
  entityDetailsForSummaryDocumentSelected: MatchedIndividualEntityDetailsForSummaryDocument | null
  setEntityDetailsForSummaryDocumentSelected: (
    value: MatchedIndividualEntityDetailsForSummaryDocument,
  ) => void
  updateEntityDetailsForSummaryDocumentSelected: (
    additional: GetAdditionalEntityDetailsForSummaryDocumentResponse,
  ) => void
}

export const useEntityDetailsForSummaryDocumentStore = create<Store>()(
  devtools(
    (set) => ({
      entityDetailsForSummaryDocumentSelected: null,
      setEntityDetailsForSummaryDocumentSelected: (
        entityDetailsForSummaryDocumentSelected,
      ) => set({ entityDetailsForSummaryDocumentSelected }),
      updateEntityDetailsForSummaryDocumentSelected: (additional) =>
        set((state) => {
          const cloneEntityDetailsForSummaryDocumentSelected = JSON.parse(
            JSON.stringify(state.entityDetailsForSummaryDocumentSelected),
          )
          return {
            entityDetailsForSummaryDocumentSelected: {
              ...cloneEntityDetailsForSummaryDocumentSelected,
              additional,
            },
          }
        }),
    }),
    { name: 'EntityDetailsForSummaryDocumentStore' },
  ),
)
